.donate__options {
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 2rem;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-around;
  }
}

.donate__option {
  display: flex;
  flex-direction: column;
  align-self: center;
  text-align: center;
  width: 80vw;
  border-radius: 5px;
  padding: 1rem;
  box-sizing: border-box;
  border: 1px solid #888;
  border: 1px solid blue;
  background-color: #111;
  cursor: pointer;
  text-decoration: auto;

  @media (min-width: 768px) {
    width: 40vw;
    align-self: unset;
  }

  &:hover {
    background-color: #222;
  }
}

.donate__image {
  display: block;
  align-self: center;
  max-width: 100%;
}
